import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Subscriptions from './pages/Subscriptions';
import SubscriptionDetails from './pages/SubscriptionDetails';
import Insights from './pages/Insights';
import Settings from './pages/Settings';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import ForgotPassword from './pages/ForgotPassword';
import OTPVerification from './pages/OTPVerification';
import ResetPassword from './pages/ResetPassword';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';
import './index.css';
export function App() {
  return <AuthProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <Routes data-id="element-2">
          {/* Public routes */}
          <Route path="/login" element={<Login data-id="element-4" />} data-id="element-3" />
          <Route path="/signup" element={<SignUp data-id="element-6" />} data-id="element-5" />
          <Route path="/forgot-password" element={<ForgotPassword data-id="element-8" />} data-id="element-7" />
          <Route path="/otp-verification" element={<OTPVerification data-id="element-10" />} data-id="element-9" />
          <Route path="/reset-password" element={<ResetPassword data-id="element-12" />} data-id="element-11" />
          {/* Protected routes */}
          <Route element={<ProtectedRoute data-id="element-14" />} data-id="element-13">
            <Route path="/" element={<Layout data-id="element-16" />} data-id="element-15">
              <Route index element={<Home data-id="element-18" />} data-id="element-17" />
              <Route path="subscriptions" element={<Subscriptions data-id="element-20" />} data-id="element-19" />
              <Route path="subscription/:id" element={<SubscriptionDetails data-id="element-22" />} data-id="element-21" />
              <Route path="insights" element={<Insights data-id="element-24" />} data-id="element-23" />
              <Route path="settings" element={<Settings data-id="element-26" />} data-id="element-25" />
            </Route>
          </Route>
          {/* Redirect any unknown routes to home */}
          <Route path="*" element={<Navigate to="/" replace data-id="element-28" />} data-id="element-27" />
        </Routes>
      </BrowserRouter>
    </AuthProvider>;
}